export var getStringWithColonSuffix = function getStringWithColonSuffix(string) {
  return "".concat(string, ": ");
};